import { render, staticRenderFns } from "./receiveList.vue?vue&type=template&id=5c2267dd&scoped=true&"
import script from "./receiveList.vue?vue&type=script&lang=js&"
export * from "./receiveList.vue?vue&type=script&lang=js&"
import style0 from "./receiveList.vue?vue&type=style&index=0&id=5c2267dd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2267dd",
  null
  
)

export default component.exports